import { VStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const HomePage = () => {
    const { t } = useTranslation("home");
    return (
        <VStack w="full" py={12} alignItems="flex-start">
            <Text fontSize="2xl" fontWeight="bold">{t("homePage.title")}</Text>
            <Text color="text.muted">{t("homePage.comingSoon")}</Text>
        </VStack>
    );
};

export default HomePage;
